document.addEventListener('DOMContentLoaded', function () {
  /*
      FULL SCREEN CONTENT
  */
  var fullscreenSections = document.querySelectorAll('.fullscreen section');
  fullscreenSections.forEach(function (viewer) {
    var pages = viewer.querySelector('ul.pages');
    var thumbs = viewer.querySelector('ul.thumbs');
    var pageList = Array.from(pages.children).map(function (page, index) {
      // background
      var backgroundElements = page.querySelectorAll('[data-background]');
      backgroundElements.forEach(function (backgroundElement) {
        backgroundElement.style.background = 'url("' + backgroundElement.getAttribute('data-background') + '") no-repeat center center';
        backgroundElement.style.backgroundSize = 'cover';
        backgroundElement.removeAttribute('data-background');
      });
      // img
      var imgElements = page.querySelectorAll('img[data-src]');
      imgElements.forEach(function (imgElement) {
        imgElement.src = imgElement.getAttribute('data-src');
        imgElement.removeAttribute('data-src');
      });

      var thumb = document.createElement('li');
      thumb.setAttribute('data-id', index);
      thumb.addEventListener('click', function () {
        changePage(parseInt(this.getAttribute('data-id')));
      });
      thumbs.appendChild(thumb);
      return page.cloneNode(true);
    });

    pages.innerHTML = '';
    // pageList.forEach(function (page, index) {
      // pages.appendChild(page);
    // });

    var showPage = null;
    var pageId = 0;
    var c = getQuery(location.href, 'content');
    if (c) {
      for (pageId = 0; pageId < pageList.length; ++pageId) {
        if (pageList[pageId].classList.contains(c)) {
          break;
        }
      }
      if (pageId >= pageList.length) {
        pageId = 0;
      }
    }

    function changePage(_page) {
      var hidePage = showPage;
      var newPageId = (_page + pageList.length) % pageList.length;
      var newPage = pageList[newPageId].cloneNode(true);
      pages.insertBefore(newPage, pages.firstChild);

      if (showPage) {
        if (pages.querySelector('.playvimeo')) {
          initPlayVimeo(pages.querySelector('.playvimeo'));
        }
      }

      thumbs.querySelectorAll('li').forEach(function (li) {
        li.classList.remove('on');
      });
      thumbs.querySelectorAll('li')[newPageId].classList.add('on');
      newPage.style.display = 'block';
      if (hidePage) {
        newPage.style.transition = 'none';
      }
      viewer.classList.add('changing');
        if (hidePage) {
          hidePage.style.transition = 'opacity 1.5s';
          hidePage.style.opacity = 0;
          hidePage.addEventListener('transitionend', function () {
            hidePage.remove();
            viewer.classList.remove('changing');
          });
        } else {
          viewer.classList.remove('changing');
        }
        // newPage.classList.add('show');
      newPage.classList.add('show');
      showPage = newPage;
      pageId = newPageId;
    }
    changePage(pageId);

    viewer.querySelector('.scrolldown').addEventListener('click', function () {
      changePage(pageId + 1);
    });

    var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
    document.addEventListener(mousewheelevent, function (e) {
      if (!viewer.classList.contains('changing')) {
        e.preventDefault();
        var delta = e.deltaY ? -e.deltaY : e.wheelDelta ? e.wheelDelta : -e.detail;
        changePage(pageId + (delta < 0 ? 1 : -1));
      }
    }, { passive: false });


    var tsx, tsy;
    var touching = false;
    pages.addEventListener('touchstart', function (e) {
      touching = true;
      tsx = e.changedTouches[0].pageX;
      tsy = e.changedTouches[0].pageY;
    });
    pages.addEventListener('touchmove', function (e) {
      if (touching) {
        var tmx = e.changedTouches[0].pageX - tsx;
        var tmy = e.changedTouches[0].pageY - tsy;
        if (Math.abs(tmy) > Math.abs(tmx) * 3) {
          if (tmy > 40) {
            changePage(pageId - 1);
            touching = false;
            e.preventDefault();
            return false;
          } else if (tmy < -40) {
            changePage(pageId + 1);
            touching = false;
            e.preventDefault();
            return false;
          }
        }
      }
    });
    pages.addEventListener('touchend', function () {
      touching = false;
    });
  });

  /****************
   VIMEO再生
   ****************/
  function initPlayVimeo(_targ) {
    var vimeoId = _targ.getAttribute('data-id');
    var bgVideo = _targ.parentElement.querySelector('video');

    _targ.querySelector('.play').addEventListener('click', function () {

      var player = document.createElement('div');
      player.id = 'vimeo-player';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&title=0&byline=0&portrait=0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay';
      iframe.allowFullscreen = true;
      player.appendChild(iframe);
      var closeBtn = document.createElement('div');
      closeBtn.className = 'close-btn';
      player.appendChild(closeBtn);
      document.body.appendChild(player);

      if (bgVideo) {
        bgVideo.pause();
      }

      const sliderViewer = document.querySelector('.slider .viewer');
      if (sliderViewer) {
        sliderViewer.classList.add('blur');
      }

      setTimeout(function () {
        player.style.opacity = 1;

        closeBtn.addEventListener('click', function () {
          if (bgVideo) {
            bgVideo.play();
          }
          if (player.style.display !== 'none') {
            if (sliderViewer) {
              sliderViewer.classList.remove('blur');
            }
            player.style.transition = 'opacity 1.5s';
            player.style.opacity = 0;
            player.addEventListener('transitionend', function () {
              player.remove();
            });
          }
        });
      }, 300);
    });
  }
  var playVimeoElements = document.querySelectorAll('.playvimeo');
  playVimeoElements.forEach(function (element) {
    initPlayVimeo(element);
  });

  /*
      コンテンツまでスクロール
  */
  var scrollButtons = document.querySelectorAll('*[data-scroll-to]');
  scrollButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      scrollTo(button.getAttribute('data-scroll-to'), 40);
    });
  });

  /*
      クエリーにcontentが含まれていた場合、そこに移動
  */
  var scrollTarget = getQuery(location.href, 'content');
  if (scrollTarget) {
    scrollTo(scrollTarget, 40);
  }

  function getQuery(url, name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function imagesLoaded(elem, callback) {
    var images = elem.querySelectorAll('img');
    var totalImages = images.length;
    var loadedImages = 0;
    images.forEach(function (image) {
      if (image.complete) {
        image.onload = function () {
          loadedImages++;
          if (loadedImages === totalImages) {
            callback();
          }
        };
      } else {
        image.addEventListener('load', function () {
          loadedImages++;
          if (loadedImages === totalImages) {
            callback();
          }
        });
      }
    });
  }

  function scrollTo(targetId, duration) {
    var target = document.getElementById(targetId);
    if (target) {
      var targetTop = target.offsetTop;
      var currentTop = window.scrollY || window.pageYOffset;
      var distance = targetTop - currentTop;
      var startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var timeElapsed = currentTime - startTime;
        var run = easeInOutQuad(timeElapsed, currentTop, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    }
  }
});


/* フォーム用同意チェック */
const agreeCheckbox = document.querySelector("#js-agree_check");
const submitBtn = document.querySelector("#contactFormSubmit");

function toggleSubmitButtonState() {
  submitBtn.disabled = !agreeCheckbox.checked;
}
if (agreeCheckbox && submitBtn) {
  window.addEventListener("load", function() {
    submitBtn.disabled = true;
  });
  agreeCheckbox.addEventListener("click", toggleSubmitButtonState);
}


